import httpClient from '../api/httpClient'

const BASE_URL = '/refimages'

export const getPersonImages = (payload) => httpClient.get(`${BASE_URL}/${payload.deceasedId}/images?pageSize=${payload.pageSize}&pageNumber=${payload.pageIndex}`)

export const getPersonImageById = ({ personId, entityId }) => 
  httpClient.get(`${BASE_URL}/${personId}/image/${entityId}`)

export const deletePersonImage = (id) => httpClient.delete(`${BASE_URL}/delete`, { data: { Id: id } })

export const updateImageDetails = (payload) => httpClient.put(`${BASE_URL}/update`, payload)

export const getImagesOrder = (payload) => httpClient.get(`${BASE_URL}/${payload}/allimagesname`)

export const saveImagesOrder = (payload) => httpClient.put(`${BASE_URL}/updateOrder`, payload)

export default {
  getPersonImageById,
  getPersonImages,
  deletePersonImage,
  updateImageDetails,
  getImagesOrder,
  saveImagesOrder
}